import { apiCall } from '../../../_services/apiCall';
import config from '../../../config/config.json';

const BASE_URL = `${config.POSTLOGIN_API_URL_COMPANY}authorization`;

// ---- Capabilities ----
export const getCapabilities = async () => {
  const response = await apiCall(`${BASE_URL}/capabilities`, {}, {}, 'GET');
  return response?.data || [];
};

export const assignCapability = async (data) => {
  const response = await apiCall(`${BASE_URL}/capabilities/assign`, {}, data, 'POST');
  return response?.data;
};

// ---- Roles ----
export const getRoles = async () => {
  const response = await apiCall(`${BASE_URL}/roles`, {}, {}, 'GET');
  return response?.data || [];
};

export const createRole = async (data) => {
  const response = await apiCall(`${BASE_URL}/roles`, {}, data, 'POST');
  return response?.data;
};

export const updateRole = async (roleId, data) => {
  const response = await apiCall(`${BASE_URL}/roles/${roleId}`, {}, data, 'PATCH');
  return response?.data;
};

export const getRoleCapabilities = async (roleId) => {
  const response = await apiCall(`${BASE_URL}/roles/${roleId}/capabilities`, {}, {}, 'GET');
  return response?.data || [];
};

export const addCapabilitiesToRole = async (data) => {
  const response = await apiCall(`${BASE_URL}/roles/capabilities`, {}, data, 'POST');
  return response?.data;
};

export const deleteRole = async (roleId) => {
  const response = await apiCall(`${BASE_URL}/roles/${roleId}`, {}, {}, 'DELETE');
  return response?.data;
};

export const getSystemRolePermissions = async () => {
  const response = await apiCall(`${BASE_URL}/roles/system-permissions`, {}, {}, 'GET');
  return response?.data || {};
};

export const assignRole = async (data) => {
  const response = await apiCall(`${BASE_URL}/roles/assign`, {}, data, 'POST');
  return response?.data;
};

export const unassignRole = async (data) => {
  const response = await apiCall(`${BASE_URL}/roles/unassign`, {}, data, 'POST');
  return response?.data;
};

// ---- User Permissions ----
export const getUserPermissions = async (userId) => {
  const response = await apiCall(`${BASE_URL}/users/${userId}/permissions`, {}, {}, 'GET');
  return response?.data || [];
};

// ---- Users ----
export const getUsers = async () => {
  const response = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}users`, {}, {}, 'GET');
  return response?.data || [];
};

// ---- Resource Types ----
export const getResourceTypes = async () => {
  const response = await apiCall(`${BASE_URL}/resource-types`, {}, {}, 'GET');
  return response?.data || [];
};

// ---- Resources ----
export const getResources = async (resourceType, parentId = null, filters = {}) => {
  const params = new URLSearchParams({ resourceType });
  if (parentId) params.append('parentId', parentId);
  Object.entries(filters).forEach(([k, v]) => params.append(k, v));
  const response = await apiCall(`${BASE_URL}/resources?${params}`, {}, {}, 'GET');
  return response?.data || [];
};

export const getResourceOptions = async ({ resourceType, resourceId } = {}) => {
  const params = new URLSearchParams();
  if (resourceType) params.append('resourceType', resourceType);
  else if (resourceId) params.append('resourceId', resourceId);
  const response = await apiCall(`${BASE_URL}/resources/options?${params}`, {}, {}, 'GET');
  return response?.data || [];
};

export const getResourceTags = async (resourceType) => {
  const response = await apiCall(`${BASE_URL}/resources/tags?resourceType=${resourceType}`, {}, {}, 'GET');
  return response?.data || {};
};

// ---- Authorization Check ----
export const checkAuthorize = async (data) => {
  const response = await apiCall(`${BASE_URL}/authorize`, {}, data, 'POST');
  return response?.data;
};